export const calculateRoofPitchPrice = ({
	params,
	const_var,
	post_data,
	t_c,
	UpdatePriceRecord,
	CalCulateRoofBasePrice,
	CalCulateRoofUtilityEndPrice,
	CalCulateRoofEndClosePrice,
	CalCulateRoofEndGablePrice,
	convertToTwoDecimalNumber
}) => {
	const roofPitchData = const_var?.b_r_p_a?.[params?.b_r_p];

	if (params?.b_r_p === "Select" || !roofPitchData) {
		post_data.building.roof_pitch = "312";
		post_data.building.roof_pitch_name = "312";
		post_data.building.roof_pitch_price = 0;

		return {
			post_data,
			t_c
		};
	}

	const { cost_type, cost, percentage_of, roof_pitch, custom_name } = roofPitchData;

	let roofPitchPrice = 0;

	if (cost_type === "%") {
		let calculationBase = 0;

		const percentageOfArray = percentage_of && percentage_of != 0 ? percentage_of.split(",") : [];

		if (percentageOfArray.length) {
			if (percentageOfArray.includes("1")) {
				calculationBase += parseFloat(CalCulateRoofBasePrice || 0);
			}

			if (percentageOfArray.includes("2")) {
				if (parseFloat(CalCulateRoofUtilityEndPrice || 0) !== 0) {
					calculationBase += parseFloat(CalCulateRoofUtilityEndPrice || 0);
				}

				calculationBase += parseFloat(CalCulateRoofEndClosePrice || 0);
			}

			if (percentageOfArray.includes("3")) {
				calculationBase += parseFloat(CalCulateRoofEndGablePrice || 0);
			}
		} else {
			calculationBase += parseFloat(CalCulateRoofBasePrice || 0);
		}

		if (UpdatePriceRecord === true && const_var?.UpdatedPriceData?.roof_pitch_price_changed !== true) {
			roofPitchPrice = const_var?.UpdatedPriceData?.roof_pitch_price || 0;
		} else {
			roofPitchPrice = cost == 0 ? 0 : (calculationBase * parseFloat(cost || 0)) / 100;
		}

		roofPitchPrice = convertToTwoDecimalNumber(roofPitchPrice || 0);

		t_c = parseFloat(t_c) + roofPitchPrice;
	} else {
		roofPitchPrice = UpdatePriceRecord === true && const_var?.UpdatedPriceData?.roof_pitch_price_changed !== true ? const_var?.UpdatedPriceData?.roof_pitch_price || 0 : parseFloat(cost || 0);

		t_c = parseFloat(t_c) + parseFloat(roofPitchPrice || 0);
	}

	post_data.building.roof_pitch = roof_pitch;
	post_data.building.roof_pitch_name = roof_pitch;
	post_data.building.roof_pitch_custom_name = custom_name;
	post_data.building.roof_pitch_price = roofPitchPrice;

	return {
		post_data,
		t_c,
		roofPitchPrice
	};
};
export const calculateLegsPrice = ({ post_data, params, const_var, heightFullData, UpdatePriceRecord, t_c }) => {
	const heightData = heightFullData?.[0] || {};

	const isUpdatedPrice = UpdatePriceRecord === true && const_var?.UpdatedPriceData?.height_price_changed !== true;

	let heightPrice = 0;

	if (isUpdatedPrice) {
		heightPrice = const_var.UpdatedPriceData.height_price;
	} else {
		const legType = const_var?.legstype || "";
		const isDoubleLeg = params?.p_e_l === true;
		const isLadderOrZigzag = legType.includes("ladder") || legType.includes("zigzag");
		const isDoubleLegType = legType.includes("double");

		if (const_var.g_v == 14) {
			if (isDoubleLeg && isLadderOrZigzag) {
				heightPrice =
					heightData?.ladder_cost && heightData.ladder_cost != 0 ? heightData.ladder_cost : heightData?.double_leg_baserail_cost != 0 ? heightData.double_leg_baserail_cost : heightData?.leg_height_cost || 0;
			} else if (isDoubleLeg && isDoubleLegType && heightData?.double_leg_baserail_cost != 0) {
				heightPrice = heightData?.double_leg_baserail_cost || 0;
			} else {
				heightPrice = heightData?.leg_height_cost || 0;
			}
		} else if (const_var.g_v == 12) {
			if (isDoubleLeg && isLadderOrZigzag) {
				heightPrice =
					heightData?.ladder_cost && heightData.ladder_cost != 0
						? heightData.ladder_cost
						: heightData?.double_leg_baserail_cost_12 != 0
							? heightData.double_leg_baserail_cost_12
							: heightData?.double_leg_baserail_cost || 0;
			} else if (isDoubleLeg && isDoubleLegType) {
				heightPrice = heightData?.double_leg_baserail_cost_12 != 0 ? heightData.double_leg_baserail_cost_12 : heightData?.double_leg_baserail_cost || 0;
			} else {
				heightPrice = heightData?.leg_height_cost_12 != 0 ? heightData.leg_height_cost_12 : heightData?.leg_height_cost || 0;
			}
		}
	}

	post_data.building.height_price = heightPrice;
	post_data.building.has_double_leg_price = heightPrice;

	return parseFloat(t_c || 0) + parseFloat(heightPrice || 0);
};
export const endJtrimCalculation = ({ params, cbData, const_var, extra_items, UpdatePriceRecord, convertToTwoDecimalNumber, t_c }) => {
	let isJtrimEnd = false;
	let isJtrimEndPriceCenter = false;
	let isJtrimEndPriceLeftLean = false;
	let isJtrimEndPriceRightLean = false;
	let isJtrimEndPriceFrontLean = false;
	let isJtrimEndPriceBackLean = false;
	let centerBuildingNumber = 1;
	let leftBuildingNumber = 1;
	let rightBuildingNumber = 1;
	let frontBuildingNumber = 1;
	let backBuildingNumber = 1;
	if (params.p_f_w !== "Close" && params.p_f_w !== "Open" && params.p_f_w !== "Half Dutch End" && params.p_f_w !== "Half End") {
		isJtrimEnd = true;
		isJtrimEndPriceCenter = true;
		centerBuildingNumber = params.p_b_w !== "Close" && params.p_b_w !== "Open" && params.p_b_w !== "Half Dutch End" && params.p_b_w !== "Half End" ? 2 : 1;
	} else {
		centerBuildingNumber = 1;
	}
	if (params.p_b_w !== "Close" && params.p_b_w !== "Open" && params.p_b_w !== "Half Dutch End" && params.p_b_w !== "Half End") {
		isJtrimEnd = true;
		isJtrimEndPriceCenter = true;
		centerBuildingNumber = params.p_f_w !== "Close" && params.p_f_w !== "Open" && params.p_f_w !== "Half Dutch End" && params.p_f_w !== "Half End" ? 2 : 1;
	} else {
		centerBuildingNumber = 1;
	}
	if (params.p_b_c_b_l_f != "Open" && params.p_b_c_b_l_f != "Close") {
		isJtrimEnd = true;
		isJtrimEndPriceLeftLean = true;
		leftBuildingNumber = params.p_b_c_b_l_b != "Open" && params.p_b_c_b_l_b != "Close" && params.p_b_c_b_l_b != "Half Dutch End" && params.p_b_c_b_l_b != "Half End" ? 2 : 1;
	} else {
		leftBuildingNumber = 1;
	}
	if (params.p_b_c_b_l_b != "Open" && params.p_b_c_b_l_b != "Close") {
		isJtrimEnd = true;
		isJtrimEndPriceLeftLean = true;
		leftBuildingNumber = params.p_b_c_b_l_f != "Open" && params.p_b_c_b_l_f != "Close" && params.p_b_c_b_l_f != "Half Dutch End" && params.p_b_c_b_l_f != "Half End" ? 2 : 1;
	} else {
		leftBuildingNumber = 1;
	}

	if (params.p_b_c_b_f_f != "Open" && params.p_b_c_b_f_f != "Close") {
		isJtrimEnd = true;
		isJtrimEndPriceFrontLean = true;
		frontBuildingNumber = params.p_b_c_b_f_b != "Open" && params.p_b_c_b_f_b != "Close" && params.p_b_c_b_f_b != "Half Dutch End" && params.p_b_c_b_f_b != "Half End" ? 2 : 1;
	} else {
		frontBuildingNumber = 1;
	}
	if (params.p_b_c_b_f_b != "Open" && params.p_b_c_b_f_b != "Close") {
		isJtrimEnd = true;
		isJtrimEndPriceFrontLean = true;
		frontBuildingNumber = params.p_b_c_b_f_f != "Open" && params.p_b_c_b_f_f != "Close" && params.p_b_c_b_f_f != "Half Dutch End" && params.p_b_c_b_f_f != "Half End" ? 2 : 1;
	} else {
		frontBuildingNumber = 1;
	}
	if (params.p_b_c_b_b_f != "Open" && params.p_b_c_b_b_f != "Close") {
		isJtrimEnd = true;
		isJtrimEndPriceBackLean = true;
		backBuildingNumber = params.p_b_c_b_b_b != "Open" && params.p_b_c_b_b_b != "Close" && params.p_b_c_b_b_b != "Half Dutch End" && params.p_b_c_b_b_b != "Half End" ? 2 : 1;
	} else {
		backBuildingNumber = 1;
	}

	if (params.p_b_c_b_b_b != "Open" && params.p_b_c_b_b_b != "Close") {
		isJtrimEnd = true;
		isJtrimEndPriceBackLean = true;
		backBuildingNumber = params.p_b_c_b_b_f != "Open" && params.p_b_c_b_b_f != "Close" && params.p_b_c_b_b_f != "Half Dutch End" && params.p_b_c_b_b_f != "Half End" ? 2 : 1;
	} else {
		backBuildingNumber = 1;
	}

	if (params.p_b_c_b_r_f != "Open" && params.p_b_c_b_r_f != "Close") {
		isJtrimEnd = true;
		isJtrimEndPriceRightLean = true;
		rightBuildingNumber = params.p_b_c_b_r_b != "Open" && params.p_b_c_b_r_b != "Close" && params.p_b_c_b_r_b != "Half Dutch End" && params.p_b_c_b_r_b != "Half End" ? 2 : 1;
	} else {
		rightBuildingNumber = 1;
	}
	if (params.p_b_c_b_r_b != "Open" && params.p_b_c_b_r_b != "Close") {
		isJtrimEnd = true;
		isJtrimEndPriceRightLean = true;
		rightBuildingNumber = params.p_b_c_b_r_f != "Open" && params.p_b_c_b_r_f != "Close" && params.p_b_c_b_r_f != "Half Dutch End" && params.p_b_c_b_r_f != "Half End" ? 2 : 1;
	} else {
		rightBuildingNumber = 1;
	}
	var jtrimPrice = 0;

	let centerJtrim = cbData.jtrim.find((data) => data.type == "end");
	if (params.p_j_t_end == true && centerJtrim) {
		if (isJtrimEndPriceCenter == true) {
			jtrimPrice = parseFloat(jtrimPrice) + parseFloat(centerJtrim.cost) * parseFloat(centerBuildingNumber);
		} else {
			jtrimPrice = parseFloat(jtrimPrice) + 0;
		}

		let rightJtrim = const_var.leanGetDataRight != "" && const_var.leanGetDataRight.jtrim.length > 0 ? const_var.leanGetDataRight.jtrim.find((data) => data.type == "end") : undefined;
		let frontJtrim = const_var.leanGetDataFront != "" && const_var.leanGetDataFront.jtrim.length > 0 ? const_var.leanGetDataFront.jtrim.find((data) => data.type == "end") : undefined;
		let backJtrim = const_var.leanGetDataBack != "" && const_var.leanGetDataBack.jtrim.length > 0 ? const_var.leanGetDataBack.jtrim.find((data) => data.type == "end") : undefined;
		let leftJtrim = const_var.leanGetDataLeft != "" && const_var.leanGetDataLeft.jtrim.length > 0 ? const_var.leanGetDataLeft.jtrim.find((data) => data.type == "end") : undefined;

		if (
			rightJtrim != undefined &&
			params.add_right_lean == true &&
			const_var.leanGetDataRight != "" &&
			const_var.leanGetDataRight.jtrim.length > 0 &&
			isJtrimEndPriceRightLean == true &&
			leftJtrim != undefined &&
			params.add_left_lean == true &&
			const_var.leanGetDataLeft != "" &&
			const_var.leanGetDataLeft.jtrim.length > 0 &&
			isJtrimEndPriceLeftLean == true &&
			frontJtrim != undefined &&
			params.add_front_lean == true &&
			const_var.leanGetDataFront != "" &&
			const_var.leanGetDataFront.jtrim.length > 0 &&
			isJtrimEndPriceFrontLean == true &&
			backJtrim != undefined &&
			params.add_back_lean == true &&
			const_var.leanGetDataBack != "" &&
			const_var.leanGetDataBack.jtrim.length > 0 &&
			isJtrimEndPriceBackLean == true
		) {
			if (isJtrimEndPriceCenter == true) {
				jtrimPrice =
					parseFloat(jtrimPrice) +
					parseFloat(leftJtrim.cost) * parseFloat(leftBuildingNumber) +
					parseFloat(rightJtrim.cost) * parseFloat(rightBuildingNumber) +
					parseFloat(frontJtrim.cost) * parseFloat(frontBuildingNumber) +
					parseFloat(backJtrim.cost) * parseFloat(backBuildingNumber);
			} else {
				jtrimPrice =
					parseFloat(jtrimPrice) +
					parseFloat(leftJtrim.cost) * parseFloat(leftBuildingNumber) +
					parseFloat(rightJtrim.cost) * parseFloat(rightBuildingNumber) +
					parseFloat(frontJtrim.cost) * parseFloat(frontBuildingNumber) +
					parseFloat(backJtrim.cost) * parseFloat(backBuildingNumber);
			}
		} else {
			if (rightJtrim != undefined && params.add_right_lean == true && const_var.leanGetDataRight != "" && const_var.leanGetDataRight.jtrim.length > 0 && isJtrimEndPriceRightLean == true) {
				if (isJtrimEndPriceCenter == true) {
					jtrimPrice = parseFloat(jtrimPrice) + parseFloat(rightJtrim.cost) * parseFloat(rightBuildingNumber);
				} else {
					jtrimPrice = parseFloat(jtrimPrice) + parseFloat(rightJtrim.cost) * parseFloat(rightBuildingNumber);
				}
			}
			if (frontJtrim != undefined && params.add_front_lean == true && const_var.leanGetDataFront != "" && const_var.leanGetDataFront.jtrim.length > 0 && isJtrimEndPriceFrontLean == true) {
				if (isJtrimEndPriceCenter == true) {
					jtrimPrice = parseFloat(jtrimPrice) + parseFloat(frontJtrim.cost) * parseFloat(frontBuildingNumber);
				} else {
					jtrimPrice = parseFloat(jtrimPrice) + parseFloat(frontJtrim.cost) * parseFloat(frontBuildingNumber);
				}
			}
			if (backJtrim != undefined && params.add_back_lean == true && const_var.leanGetDataBack != "" && const_var.leanGetDataBack.jtrim.length > 0 && isJtrimEndPriceBackLean == true) {
				if (isJtrimEndPriceCenter == true) {
					jtrimPrice = parseFloat(jtrimPrice) + parseFloat(backJtrim.cost) * parseFloat(backBuildingNumber);
				} else {
					jtrimPrice = parseFloat(jtrimPrice) + parseFloat(backJtrim.cost) * parseFloat(backBuildingNumber);
				}
			}
			if (leftJtrim != undefined && params.add_left_lean == true && const_var.leanGetDataLeft != "" && const_var.leanGetDataLeft.jtrim.length > 0 && isJtrimEndPriceLeftLean == true) {
				if (isJtrimEndPriceCenter == true) {
					jtrimPrice = parseFloat(jtrimPrice) + parseFloat(leftJtrim.cost) * parseFloat(leftBuildingNumber);
				} else {
					jtrimPrice = parseFloat(jtrimPrice) + parseFloat(leftJtrim.cost) * parseFloat(leftBuildingNumber);
				}
			}
		}

		const d = const_var.isLTBuilding ? const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]?.["End Jtrim"] : const_var.UpdatedPriceData?.["elements"]?.["End Jtrim"];

		extra_items.push({
			is_edit: UpdatePriceRecord == true && d != undefined && d.is_edit != undefined ? d.is_edit : false,
			item_name: "End Jtrim",
			item_quantity: params.p_j_t_end == true ? 1 : 0,
			item_price: UpdatePriceRecord == true && d != undefined && d.is_edit == true ? d?.item_price : convertToTwoDecimalNumber(jtrimPrice)
		});
		t_c = UpdatePriceRecord == true && d != undefined && d.is_edit == true ? parseFloat(t_c) + parseFloat(d?.item_price ?? 0) : parseFloat(t_c) + parseFloat(jtrimPrice);
	}
	return {
		t_c,
		extra_items
	};
};
export const jtrimCalculation = ({ params, cbData, const_var, extra_items, UpdatePriceRecord, convertToTwoDecimalNumber, t_c }) => {
	let isJtrim = false;
	let isJtrimPriceCenter = false;
	let isJtrimPriceLeftLean = false;
	let isJtrimPriceFrontLean = false;
	let isJtrimPriceBackLean = false;
	let isJtrimPriceRightLean = false;
	let centerBuildingNumber = 1;
	let checkWallPanelActiveLeft = 1;
	let checkWallPanelActiveRight = 1;
	let SideWallLeft = 0;
	let SideWallRight = 0;
	if (params.p_l_w !== "Close" && params.p_l_w !== "Open") {
		isJtrim = true;
		isJtrimPriceCenter = true;
		centerBuildingNumber = params.p_r_w !== "Close" && params.p_r_w !== "Open" ? 2 : 1;
		checkWallPanelActiveLeft = centerBuildingNumber;
		SideWallLeft = 1;
	} else {
		centerBuildingNumber = 1;
		checkWallPanelActiveLeft = 1;
		SideWallLeft = 0;
	}

	if (params.p_r_w !== "Close" && params.p_r_w !== "Open") {
		isJtrim = true;
		isJtrimPriceCenter = true;
		centerBuildingNumber = params.p_l_w !== "Close" && params.p_l_w !== "Open" ? 2 : 1;
		checkWallPanelActiveRight = centerBuildingNumber;
		SideWallRight = 1;
	} else {
		centerBuildingNumber = 1;
		checkWallPanelActiveRight = 1;
		SideWallRight = 0;
	}
	if (params.p_c_p_l == true && params.p_l_w == "Open") {
		isJtrim = true;
		isJtrimPriceCenter = true;
		centerBuildingNumber = params.p_c_p_r == true || (params.p_r_w !== "Close" && params.p_r_w !== "Open") ? 2 : centerBuildingNumber;
		SideWallLeft = SideWallLeft != 0 ? SideWallLeft + 1 : 1;
	}
	if (params.p_c_p_l == true && params.p_l_w !== "Close" && params.p_l_w !== "Open") {
		SideWallLeft = SideWallLeft != 0 ? SideWallLeft + 1 : 1;
	}
	if (params.p_c_p_r == true && params.p_r_w == "Open") {
		isJtrim = true;
		isJtrimPriceCenter = true;
		centerBuildingNumber = params.p_c_p_l == true || (params.p_l_w !== "Close" && params.p_l_w !== "Open") ? 2 : centerBuildingNumber;
		SideWallRight = SideWallRight != 0 ? SideWallRight + 1 : 1;
	}
	if (params.p_c_p_r == true && params.p_r_w !== "Close" && params.p_r_w !== "Open") {
		SideWallRight = SideWallRight != 0 ? SideWallRight + 1 : 1;
	}

	if (params.p_b_c_b_l !== "Close" && params.p_b_c_b_l !== "Open") {
		isJtrim = true;
		isJtrimPriceLeftLean = true;
	}
	if (params.p_b_c_b_l_r !== "Close" && params.p_b_c_b_l_r !== "Open") {
		isJtrim = true;
		isJtrimPriceLeftLean = true;
	}
	if (params.p_b_c_b_f_l !== "Close" && params.p_b_c_b_f_l !== "Open") {
		isJtrim = true;
		isJtrimPriceFrontLean = true;
	}
	if (params.p_b_c_b_f_r !== "Close" && params.p_b_c_b_f_r !== "Open") {
		isJtrim = true;
		isJtrimPriceFrontLean = true;
	}
	if (params.p_b_c_b_b_l !== "Close" && params.p_b_c_b_b_l !== "Open") {
		isJtrim = true;
		isJtrimPriceBackLean = true;
	}
	if (params.p_b_c_b_b_r !== "Close" && params.p_b_c_b_b_r !== "Open") {
		isJtrim = true;
		isJtrimPriceBackLean = true;
	}

	if (params.p_b_c_b_r !== "Close" && params.p_b_c_b_r !== "Open") {
		isJtrim = true;
		isJtrimPriceRightLean = true;
	}
	if (params.p_b_c_b_r_r !== "Close" && params.p_b_c_b_r_r !== "Open") {
		isJtrim = true;
		isJtrimPriceRightLean = true;
	}

	if (isJtrim != true) {
		params.p_j_t = false;
	}
	var jtrimPrice = 0;

	let JtrimVal = 0;
	if (params.p_j_t == true) {
		JtrimVal = 1;
	}
	if (params.p_j_t == true) {
		let sideJtrimP = cbData.jtrim.find((data) => data.type == "side");
		let centerJtrimPriceL = 0;
		let centerJtrimPriceR = 0;
		if (isJtrimPriceCenter == true && sideJtrimP) {
			let newCutPanelJtrim_Price = 0;
			if (params.p_c_p_l == true || params.p_c_p_r == true) {
				newCutPanelJtrim_Price = sideJtrimP.cut_panel_jtrim != undefined ? sideJtrimP.cut_panel_jtrim : 0;
			}
			if (sideJtrimP.is_cut_panel_jtrim != undefined && SideWallLeft == 2) {
				centerJtrimPriceL = sideJtrimP.is_cut_panel_jtrim == "included" || sideJtrimP.is_panel_jtrim == "included" ? 0 : parseFloat(sideJtrimP.cost) + parseFloat(sideJtrimP.cut_panel_jtrim);
			} else {
				if (SideWallLeft == 1) {
					if (params.p_c_p_l == true) {
						centerJtrimPriceL =
							sideJtrimP.is_cut_panel_jtrim == "included" || sideJtrimP.is_cut_panel_jtrim == "no"
								? 0
								: parseFloat(sideJtrimP.cut_panel_jtrim) == 0
									? parseFloat(sideJtrimP.cost)
									: parseFloat(sideJtrimP.cut_panel_jtrim);
					} else {
						centerJtrimPriceL = sideJtrimP.is_panel_jtrim == "included" || sideJtrimP.is_panel_jtrim == "no" ? 0 : parseFloat(sideJtrimP.cost);
					}
				}
			}
			if (sideJtrimP.is_cut_panel_jtrim != undefined && SideWallRight == 2) {
				centerJtrimPriceR = sideJtrimP.is_cut_panel_jtrim == "included" || sideJtrimP.is_panel_jtrim == "included" ? 0 : parseFloat(sideJtrimP.cost) + parseFloat(sideJtrimP.cut_panel_jtrim);
			} else {
				if (SideWallRight == 1) {
					if (params.p_c_p_r == true) {
						centerJtrimPriceR =
							sideJtrimP.is_cut_panel_jtrim == "included" || sideJtrimP.is_cut_panel_jtrim == "no"
								? 0
								: parseFloat(sideJtrimP.cut_panel_jtrim) == 0
									? parseFloat(sideJtrimP.cost)
									: parseFloat(sideJtrimP.cut_panel_jtrim);
					} else {
						centerJtrimPriceR = sideJtrimP.is_panel_jtrim == "included" || sideJtrimP.is_panel_jtrim == "no" ? 0 : parseFloat(sideJtrimP.cost);
					}
				}
			}
			if (sideJtrimP.is_panel_jtrim != undefined) {
				jtrimPrice = parseFloat(jtrimPrice) + (parseFloat(centerJtrimPriceL) + parseFloat(centerJtrimPriceR));
			} else {
				jtrimPrice = parseFloat(jtrimPrice) + parseFloat(sideJtrimP.cost) * parseFloat(centerBuildingNumber);
			}
		} else {
			jtrimPrice = parseFloat(jtrimPrice) + 0;
		}

		const rightLeanJTrimCost = parseFloat(const_var.leanGetDataRight?.jtrim?.find((d) => d.type === "side")?.cost ?? 0);
		const leftLeanJTrimCost = parseFloat(const_var.leanGetDataLeft?.jtrim?.find((d) => d.type === "side")?.cost ?? 0);
		const frontLeanJTrimCost = parseFloat(const_var.leanGetDataFront?.jtrim?.find((d) => d.type === "side")?.cost ?? 0);
		const backLeanJTrimCost = parseFloat(const_var.leanGetDataBack?.jtrim?.find((d) => d.type === "side")?.cost ?? 0);

		if (
			params.add_right_lean == true &&
			const_var.leanGetDataRight != "" &&
			const_var.leanGetDataRight.jtrim.length > 0 &&
			isJtrimPriceRightLean == true &&
			params.add_left_lean == true &&
			const_var.leanGetDataLeft != "" &&
			const_var.leanGetDataLeft.jtrim.length > 0 &&
			isJtrimPriceLeftLean == true &&
			params.add_fron_lean == true &&
			const_var.leanGetDataFront != "" &&
			const_var.leanGetDataFront.jtrim.length > 0 &&
			isJtrimPriceFrontLean == true &&
			params.add_back_lean == true &&
			const_var.leanGetDataBack != "" &&
			const_var.leanGetDataBack.jtrim.length > 0 &&
			isJtrimPriceBackLean == true
		) {
			if (isJtrimPriceCenter == true) {
				jtrimPrice = parseFloat(jtrimPrice) + leftLeanJTrimCost + rightLeanJTrimCost + frontLeanJTrimCost + backLeanJTrimCost;
			} else {
				jtrimPrice = parseFloat(jtrimPrice) + leftLeanJTrimCost + rightLeanJTrimCost + frontLeanJTrimCost + backLeanJTrimCost;
			}
		}
		if (params.add_front_lean == true && const_var.leanGetDataFront != "" && const_var.leanGetDataFront.jtrim.length > 0 && isJtrimPriceFrontLean == true) {
			if (isJtrimPriceCenter == true) {
				jtrimPrice = parseFloat(jtrimPrice) + frontLeanJTrimCost;
			} else {
				jtrimPrice = parseFloat(jtrimPrice) + frontLeanJTrimCost;
			}
		}
		if (params.add_back_lean == true && const_var.leanGetDataBack != "" && const_var.leanGetDataBack.jtrim.length > 0 && isJtrimPriceBackLean == true) {
			if (isJtrimPriceCenter == true) {
				jtrimPrice = parseFloat(jtrimPrice) + backLeanJTrimCost;
			} else {
				jtrimPrice = parseFloat(jtrimPrice) + backLeanJTrimCost;
			}
		}
		if (params.add_right_lean == true && const_var.leanGetDataRight != "" && const_var.leanGetDataRight.jtrim.length > 0 && isJtrimPriceRightLean == true) {
			if (isJtrimPriceCenter == true) {
				jtrimPrice = parseFloat(jtrimPrice) + rightLeanJTrimCost;
			} else {
				jtrimPrice = parseFloat(jtrimPrice) + rightLeanJTrimCost;
			}
		}
		if (params.add_left_lean == true && const_var.leanGetDataLeft != "" && const_var.leanGetDataLeft.jtrim.length > 0 && isJtrimPriceLeftLean == true) {
			if (isJtrimPriceCenter == true) {
				jtrimPrice = parseFloat(jtrimPrice) + leftLeanJTrimCost;
			} else {
				jtrimPrice = parseFloat(jtrimPrice) + leftLeanJTrimCost;
			}
		}

		const d = const_var.isLTBuilding ? const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]?.["Jtrim"] : const_var.UpdatedPriceData?.["elements"]?.["Jtrim"];

		extra_items.push({
			is_edit: UpdatePriceRecord == true && d?.is_edit != undefined ? d.is_edit : false,
			item_name: "Jtrim",
			item_quantity: params.p_j_t == true ? 1 : 0,
			item_price: UpdatePriceRecord == true && d?.is_edit == true ? d?.item_price : convertToTwoDecimalNumber(jtrimPrice)
		});
		t_c = UpdatePriceRecord == true && d?.is_edit == true ? parseFloat(t_c) + parseFloat(d?.item_price ?? 0) : parseFloat(t_c) + parseFloat(jtrimPrice);
	}
};
